export default __webpack_public_path__ + "static/media/error.42292aa1.gif";